import { render, staticRenderFns } from "./ImportPortfolioStep1.vue?vue&type=template&id=0459a5d5&scoped=true&"
import script from "./ImportPortfolioStep1.vue?vue&type=script&lang=js&"
export * from "./ImportPortfolioStep1.vue?vue&type=script&lang=js&"
import style0 from "./ImportPortfolioStep1.vue?vue&type=style&index=0&id=0459a5d5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0459a5d5",
  null
  
)

export default component.exports